/* @flow */

import * as React from 'react';
import * as cssUtils from 'app/utils/cssUtils';
import classNames from 'classnames';
import useSheet from 'app/jss';
import IconButton from 'app/components/commons/IconButton';

type Props = {
  children: any,
  className?: string,
  classes: Object,
  visible?: boolean,
};

type State = {
  isOpen: boolean,
};

class KebabMenu extends React.Component<Props, State> {
  props: Props;

  state: State = {
    isOpen: false,
  };

  static defaultProps = {
    className: undefined,
    visible: true,
  };

  componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  }

  handleKebabClick = () => {
    this.setState(state => ({
      isOpen: !state.isOpen,
    }));
  };

  handleItemClick = () => {
    this.setState({
      isOpen: false,
    });
  };

  handleOutsideClick = (event: Event) => {
    const { classes } = this.props;

    if (!event.target.closest(`.${classes.pitaBread}`)) {
      this.setState({
        isOpen: false,
      });
    }
  };

  render() {
    const {
      children,
      classes,
      className,
      visible,
    } = this.props;
    const { isOpen } = this.state;

    return (
      <div className={classNames(classes.pitaBread, className)}>
        <IconButton
          type="icon-more-vertical"
          onClick={this.handleKebabClick}
          className={classNames(classes.kebabButton, { visible })}
          stopPropagation
          preventDefault
          onRef={(ref) => {
            this.menuItem = ref;
          }}
        />
        <div
          className={classNames(classes.kebabList, { isOpen })}
          ref={(ref) => {
            this.list = ref;
          }}
        >
          <div className={classes.triangleArrow} />
          <div className={classes.kebabContent}>
            {React.Children.map(children, child => (
              React.cloneElement(child, {
                ...child.props,
                onItemClick: this.handleItemClick,
              })
            ))}
          </div>
        </div>
      </div>
    );
  }
}

function applyStyles(theme: Theme) {
  const pendingColor = theme.color.basis4 || theme.color.basis4;
  return {
    pitaBread: {
      position: 'relative',
      display: 'flex',
    },
    kebabList: {
      position: 'absolute',
      top: 46,
      right: 12,
      background: theme.color.basis1,
      borderRadius: 8,
      boxShadow: `0px 4px 14px -4px ${theme.color.basis1}`,
      opacity: 0,
      pointerEvents: 'none',
      minWidth: 130,
      transition: 'opacity 0.3s, transform 0.3s ease-in-out',
      transform: 'scale(0)',
      transformOrigin: '90% 0',
      zIndex: 1,
      '&.isOpen': {
        pointerEvents: 'auto',
        opacity: 1,
        transform: 'scale(1)',
      },
    },
    kebabContent: {
      overflow: 'hidden',
    },
    triangleArrow: {
      position: 'absolute',
      top: -5,
      right: 7,
      height: 12,
      width: 12,
      background: theme.color.basis1,
      transform: 'rotate(45deg)',
      boxShadow: `0px 4px 14px -4px ${theme.color.basis1}`,
    },
    kebabButton: {
      display: 'flex',
      // padding: 10,
      width: 50,
      height: 50,
      alignItems: 'center',
      justifyContent: 'center',
      color: pendingColor,
      transform: 'scale(0)',
      pointerEvents: 'none',
      transition: ['background-color 0.1s linear', 'transform 0.2s ease-out', 'color 0.2s'].join(', '),
      '&.visible': {
        pointerEvents: 'auto',
        transform: 'scale(1)',
      },
      ...cssUtils.hover({
        color: theme.color.basis5,
      }),
    },
  };
}

export default useSheet(applyStyles)(KebabMenu);
